/**
 * Outlook Migration API Schemas
 */

import { z } from "zod";

export const OutlookDeploymentStatusSchema = z.object({
  deploymentId: z.string(),
  deploymentName: z.string(),
  organizationId: z.string(),
  connectionId: z.string(),
  accountEmail: z.string(),
  currentWebhookUrl: z.string().nullable(),
  expectedWebhookUrl: z.string(),
  needsMigration: z.boolean(),
  subscriptionExpires: z.coerce.date().nullable() // API returns string, coerce to Date
});

export const OutlookMigrationStatusResponseSchema = z.object({
  total: z.number(),
  needsMigration: z.number(),
  alreadyMigrated: z.number(),
  deployments: z.array(OutlookDeploymentStatusSchema)
});

export const MigrateOutlookWebhookBodySchema = z.object({
  connectionId: z.string().uuid()
});

export const MigrateOutlookWebhookResponseSchema = z.object({
  success: z.boolean(),
  webhookUrl: z.string().optional(),
  subscriptionExpires: z.coerce.date().nullable().optional(), // API returns string, coerce to Date
  error: z.string().optional()
});
